import{useCallback as e}from"react";function o(o){return e((function(e){32!==e.keyCode&&13!==e.keyCode||o(e)}),[o])}export{o as useKeyboardButtonPressedFunc};
